import React, { useEffect, useState } from "react";
import {
  Button,
  Form,
  FormGroup,
  Input,
  Label,
  Modal,
  ModalBody,
  ModalFooter,
  ModalHeader,
} from "reactstrap";
import {
  showErrorAlert,
  showSuccessAlert,
  showSuccessEditAlert,
} from "../../../components/alerts";
import medicGeekApi from "../../../config/axiosConfig";
import "./../../../styles/FormPro.css";

const MedicamentosList = ({
  setCurrentForm,
  currentForm,
  setSelectedMedicamentos,
}) => {
  const [medicamentos, setMedicamentos] = useState([]);
  const [showForm] = useState(false);
  const [pageNumber, setPageNumber] = useState(0);
  const medicamentosPerPage = 10;
  const [selectedMedicamentoLocal, setSelectedMedicamentosLocal] =
    useState(null);
  const [modalOpen, setModalOpen] = useState(false);
  const [isEditing, setIsEditing] = useState(false);
  const [searchTerm, setSearchTerm] = useState("");

  // Skeleton
  const [loading, setLoading] = useState(true);
  const [hasLoaded, setHasLoaded] = useState(false);

  const [formulario, setFormulario] = useState({
    nombreMedicamento: "",
    nombreComercial: "",
    dosisMedicamento: "",
    estatusMedicamento: "activo",
  });

  const openModal = (medicamento) => {
    setSelectedMedicamentosLocal(medicamento); // Configura el medicamento seleccionado para la edición

    if (medicamento) {
      setIsEditing(true); // Establecer como modo edición cuando se abre el modal
      setFormulario({
        nombreMedicamento: medicamento.producNm,
        nombreComercial: medicamento.producNc,
        dosisMedicamento: medicamento.producDs,
        estatusMedicamento: medicamento.estatus ? "activo" : "inactivo",
      });
    } else {
      setIsEditing(false); // Establecer como modo creación cuando se abre el modal para crear uno nuevo
      // Limpia los campos si es necesario
      setFormulario({
        nombreMedicamento: "",
        nombreComercial: "",
        dosisMedicamento: "",
        estatusMedicamento: "activo",
      });
    }
    setModalOpen(true);
  };

  const closeModal = () => {
    setSelectedMedicamentosLocal(null); // Limpia el Medicamento seleccionado
    setIsEditing(false); // Resetear el modo edición cuando se cierra el modal
    setModalOpen(false);
  };

  const handleSearchTermChange = (e) => {
    const searchTerm = e.target.value;
    setSearchTerm(searchTerm);
  };

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true); // Iniciar la carga
      try {
        const response = await medicGeekApi.get(`/medicamentos?search=${searchTerm}`, {
          params: {
            $or: [
              { producNm: { $regex: searchTerm, $options: "i" } },
              { producNc: { $regex: searchTerm, $options: "i" } },
            ],
          },
        });
        const sortedData = response.data.sort((a, b) => a.producId - b.producId);
        setMedicamentos(sortedData);
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false); // Finalizar carga
      }
    };
  
    fetchData();
  }, [searchTerm]);
  

  const pageCount = Math.ceil(medicamentos.length / medicamentosPerPage);

  const handlePageChange = ({ selected }) => {
    setPageNumber(selected);
  };

  const displayedmedicamentos = medicamentos
    .filter((medicamento) => {
      // Filtrar seguros basados en el término de búsqueda
      return (
        medicamento.producNm.toLowerCase().includes(searchTerm.toLowerCase()) ||
        medicamento.producNc.toLowerCase().includes(searchTerm.toLowerCase())
      );
    })
    .slice(
      pageNumber * medicamentosPerPage,
      (pageNumber + 1) * medicamentosPerPage
    );

  const updateMedicamentosList = () => {
    medicGeekApi
      .get("/medicamentos")
      .then((response) => {
        setMedicamentos(response.data);
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const guardarMedicamento = () => {
    const nuevoMedicamento = {
      producNm: document.getElementById("nombreMedicamento").value,
      producNc: document.getElementById("nombreComercial").value,
      producDs: document.getElementById("dosisMedicamento").value,
      estatus:
        document.getElementById("estatusMedicamento").value === "activo"
          ? "Activo"
          : "Inactivo",
    };
    medicGeekApi
      .post("/medicamentos", nuevoMedicamento)
      .then((response) => {
        showSuccessAlert();
        closeModal();
        updateMedicamentosList();
      })
      .catch((error) => {
        console.error("Error al crear el Medicamento", error);
      });
  };

  const editarMedicamento = () => {
    if (selectedMedicamentoLocal && selectedMedicamentoLocal.producId) {
      const { producId } = selectedMedicamentoLocal;
      const nombreMedicamento =
        document.getElementById("nombreMedicamento").value;
      const nombreComercial = document.getElementById("nombreComercial").value;
      const dosisMedicamento =
        document.getElementById("dosisMedicamento").value;
      const estatusMedicamento =
        document.getElementById("estatusMedicamento").value === "activo"
          ? "Activo"
          : "Inactivo";

      const updatedMedicamento = {
        producId, // Asegurarse de enviar el ID
        producNm: nombreMedicamento,
        producNc: nombreComercial,
        producDs: dosisMedicamento,
        estatus: estatusMedicamento,
      };

      medicGeekApi
        .patch(`/medicamentos/${producId}`, updatedMedicamento)
        .then((response) => {
          showSuccessEditAlert();
          closeModal();
          updateMedicamentosList();
        })
        .catch((error) => {
          console.error("Error al actualizar el seguro", error);
        });
    } else {
      // Manejo de error o mensaje de que no se puede actualizar
      showErrorAlert();
      console.error("No se puede actualizar: seguro no válido.");
    }
  };

  const SkeletonTableRow = () => (
    <tr>
      <td>
        <div className="skeleton-placeholder" style={{ backgroundColor: "#e0e0e0", height: "20px", width: "60px" }}></div>
      </td>
      <td>
        <div className="skeleton-placeholder" style={{ backgroundColor: "#e0e0e0", height: "20px", width: "150px" }}></div>
      </td>
      <td>
        <div className="skeleton-placeholder" style={{ backgroundColor: "#e0e0e0", height: "20px", width: "100px" }}></div>
      </td>
      <td>
        <div className="skeleton-placeholder" style={{ backgroundColor: "#e0e0e0", height: "20px", width: "70px" }}></div>
      </td>
      <td>
        <div className="skeleton-placeholder" style={{ backgroundColor: "#e0e0e0", height: "20px", width: "200px" }}></div>
      </td>
      <td>
        <div className="skeleton-placeholder" style={{ backgroundColor: "#e0e0e0", height: "20px", width: "100px" }}></div>
      </td>
      <td>
        <div className="skeleton-placeholder" style={{ backgroundColor: "#e0e0e0", height: "20px", width: "60px" }}></div>
      </td>
    </tr>
  );

  const eliminarMedicamento = async (producId) => {
    // Pregunta al usuario si desea eliminar el medicamento
    const confirmar = window.confirm("¿Estás seguro de que deseas eliminar este medicamento?");
    
    if (!confirmar) {
      // Si el usuario cancela la operación, no hacemos nada
      return;
    }
  
    try {
      await medicGeekApi.delete(`/medicamentos/${producId}`);
      // Actualiza la lista de medicamentos después de la eliminación
      setMedicamentos((prevMedicamentos) =>
        prevMedicamentos.filter((medicamento) => medicamento.producId !== producId)
      );
      showSuccessAlert("Medicamento eliminado correctamente");
    } catch (error) {
      console.error("Error al eliminar el medicamento", error);
    }
  };
  
return (
  <div className="pro-container">

    {/* ===================================================== */}
    {/* HEADER */}
    {/* ===================================================== */}

    <div className="pro-header">

      <div className="pro-header-left">

        <h2 className="pro-title">
          Vademécum
        </h2>

        <p className="pro-subtitle">
          Gestión y mantenimiento de medicamentos
        </p>

      </div>

      <div className="pro-actions">

        {/* SEARCH */}
        <div className="pro-search">

          <i className="bi bi-search"></i>

          <input
            type="search"
            placeholder="Buscar medicamento..."
            value={searchTerm}
            onChange={handleSearchTermChange}
          />

        </div>

        {/* BUTTON */}
        <button
          type="button"
          className="pro-btn-primary"
          onClick={() => openModal(null)}
        >

          <i className="bi bi-plus-circle-fill"></i>

          Nuevo Medicamento

        </button>

      </div>

    </div>

    {/* ===================================================== */}
    {/* TABLE DESKTOP */}
    {/* ===================================================== */}

    <div className="pro-card d-none d-md-block">

      <div className="table-responsive">

        <table className="table pro-table align-middle">

          <thead>

            <tr>

              <th style={{ width: "8%" }}>
                ID
              </th>

              <th style={{ width: "25%" }}>
                Nombre Genérico
              </th>

              <th style={{ width: "25%" }}>
                Nombre Comercial
              </th>

              <th style={{ width: "27%" }}>
                Dosis
              </th>

              <th
                style={{ width: "10%" }}
                className="text-center"
              >
                Estado
              </th>

              <th
                style={{ width: "10%" }}
                className="text-center"
              >
                Acciones
              </th>

            </tr>

          </thead>

          <tbody>

            {loading ? (

              Array.from({ length: 12 }).map((_, index) => (

                <tr key={index}>

                  <td>
                    <div className="skeleton-line"></div>
                  </td>

                  <td>
                    <div className="skeleton-line"></div>
                  </td>

                  <td>
                    <div className="skeleton-line"></div>
                  </td>

                  <td>
                    <div className="skeleton-line"></div>
                  </td>

                  <td>
                    <div className="skeleton-line"></div>
                  </td>

                  <td>
                    <div className="skeleton-line"></div>
                  </td>

                </tr>

              ))

            ) : (

              displayedmedicamentos.map((medicamento) => (

                <tr key={medicamento.producId}>

                  {/* ID */}
                  <td>

                    <span className="expediente-badge">

                      #
                      {medicamento.producId}

                    </span>

                  </td>

                  {/* GENERICO */}
                  <td>

                    <div className="patient-info">

                      <div className="patient-avatar">

                        {medicamento.producNm
                          ?.charAt(0)}

                      </div>

                      <div>

                        <div className="patient-name">

                          {medicamento.producNm}

                        </div>

                        <div className="patient-id">

                          Medicamento Genérico

                        </div>

                      </div>

                    </div>

                  </td>

                  {/* COMERCIAL */}
                  <td
                    className="truncate-text"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title={medicamento.producNc}
                  >

                    {medicamento.producNc?.length > 35
                      ? `${medicamento.producNc.slice(0, 35)}...`
                      : medicamento.producNc}

                  </td>

                  {/* DOSIS */}
                  <td
                    className="truncate-text"
                    data-bs-toggle="tooltip"
                    data-bs-placement="top"
                    title={medicamento.producDs}
                  >

                    {medicamento.producDs?.length > 35
                      ? `${medicamento.producDs.slice(0, 35)}...`
                      : medicamento.producDs}

                  </td>

                  {/* STATUS */}
                  <td className="text-center">

                    <span
                      className={`gender-badge ${
                        medicamento.estatus === "Activo"
                          ? ""
                          : "bg-danger-subtle text-danger"
                      }`}
                    >

                      {medicamento.estatus}

                    </span>

                  </td>

                  {/* ACTIONS */}
                  <td>

                    <div className="pro-table-actions">

                      {/* EDIT */}
                      <button
                        type="button"
                        className="pro-action-btn warning"
                        title="Editar"
                        onClick={() => openModal(medicamento)}
                      >

                        <i className="bi bi-pencil-square"></i>

                      </button>

                      {/* DELETE */}
                      <button
                        type="button"
                        className="pro-action-btn info"
                        title="Eliminar"
                        onClick={() =>
                          eliminarMedicamento(
                            medicamento.producId
                          )
                        }
                      >

                        <i className="bi bi-trash"></i>

                      </button>

                    </div>

                  </td>

                </tr>

              ))

            )}

          </tbody>

        </table>

      </div>

    </div>

    {/* ===================================================== */}
    {/* MOBILE */}
    {/* ===================================================== */}

    <div className="d-md-none">

      <div className="row g-3">

        {loading ? (

          Array.from({ length: 5 }).map((_, index) => (

            <div
              className="col-12"
              key={index}
            >

              <div className="mobile-patient-card">

                <div className="skeleton-line mb-3"></div>
                <div className="skeleton-line mb-3"></div>
                <div className="skeleton-line mb-3"></div>
                <div className="skeleton-line"></div>

              </div>

            </div>

          ))

        ) : (

          displayedmedicamentos.map((medicamento) => (

            <div
              className="col-12"
              key={medicamento.producId}
            >

              <div className="mobile-patient-card">

                {/* TOP */}
                <div className="mobile-card-top">

                  <div className="patient-info">

                    <div className="patient-avatar">

                      {medicamento.producNm
                        ?.charAt(0)}

                    </div>

                    <div>

                      <div className="patient-name">

                        {medicamento.producNm}

                      </div>

                      <div className="patient-id">

                        #{medicamento.producId}

                      </div>

                    </div>

                  </div>

                </div>

                {/* CONTENT */}
                <div className="mobile-card-content">

                  <p>

                    <strong>
                      Nombre Comercial:
                    </strong>

                    <br />

                    {medicamento.producNc}

                  </p>

                  <p>

                    <strong>
                      Dosis:
                    </strong>

                    <br />

                    {medicamento.producDs}

                  </p>

                  <p>

                    <strong>
                      Estado:
                    </strong>

                    <br />

                    <span className="gender-badge">

                      {medicamento.estatus}

                    </span>

                  </p>

                </div>

                {/* ACTIONS */}
                <div className="mobile-card-actions">

                  <button
                    type="button"
                    className="pro-action-btn warning"
                    onClick={() =>
                      openModal(medicamento)
                    }
                  >

                    <i className="bi bi-pencil-square"></i>

                  </button>

                  <button
                    type="button"
                    className="pro-action-btn info"
                    onClick={() =>
                      eliminarMedicamento(
                        medicamento.producId
                      )
                    }
                  >

                    <i className="bi bi-trash"></i>

                  </button>

                </div>

              </div>

            </div>

          ))

        )}

      </div>

    </div>

    {/* ===================================================== */}
    {/* PAGINATION */}
    {/* ===================================================== */}

    {!showForm && (

      <div className="pro-pagination">

        <nav>

          <ul className="pagination modern-pagination">

            {/* PREVIOUS */}
            <li
              className={`page-item ${
                pageNumber === 0
                  ? "disabled"
                  : ""
              }`}
            >

              <button
                className="page-link"
                onClick={() =>
                  handlePageChange({
                    selected: pageNumber - 1,
                  })
                }
              >

                <i className="bi bi-chevron-left"></i>

              </button>

            </li>

            {/* NUMBERS */}
            {Array.from(
              {
                length: Math.min(pageCount, 10),
              },
              (_, index) => (

                <li
                  key={index}
                  className={`page-item ${
                    pageNumber === index
                      ? "active"
                      : ""
                  }`}
                >

                  <button
                    className="page-link"
                    onClick={() =>
                      handlePageChange({
                        selected: index,
                      })
                    }
                  >

                    {index + 1}

                  </button>

                </li>

              )
            )}

            {/* NEXT */}
            <li
              className={`page-item ${
                pageNumber === pageCount - 1
                  ? "disabled"
                  : ""
              }`}
            >

              <button
                className="page-link"
                onClick={() =>
                  handlePageChange({
                    selected: pageNumber + 1,
                  })
                }
              >

                <i className="bi bi-chevron-right"></i>

              </button>

            </li>

          </ul>

        </nav>

      </div>

    )}

    {/* ===================================================== */}
    {/* MODAL */}
    {/* ===================================================== */}

    <Modal
      isOpen={modalOpen}
      toggle={closeModal}
      centered
      className="pro-modal"
    >

      <ModalHeader toggle={closeModal}>

        {isEditing
          ? "Editar Medicamento"
          : "Nuevo Medicamento"}

      </ModalHeader>

      <ModalBody>

        <Form className="pro-form-layout">

          {/* NOMBRE GENERICO */}
          <FormGroup floating>

            <Input
              type="text"
              id="nombreMedicamento"
              className="pro-input"
              placeholder="Nombre Genérico"
              value={formulario.nombreMedicamento}
              onChange={(e) =>
                setFormulario({
                  ...formulario,
                  nombreMedicamento: e.target.value,
                })
              }
            />

            <Label for="nombreMedicamento">
              Nombre Genérico
            </Label>

          </FormGroup>

          {/* NOMBRE COMERCIAL */}
          <FormGroup floating>

            <Input
              type="text"
              id="nombreComercial"
              className="pro-input"
              placeholder="Nombre Comercial"
              value={formulario.nombreComercial}
              onChange={(e) =>
                setFormulario({
                  ...formulario,
                  nombreComercial: e.target.value,
                })
              }
            />

            <Label for="nombreComercial">
              Nombre Comercial
            </Label>

          </FormGroup>

          {/* DOSIS */}
          <FormGroup floating>

            <Input
              type="text"
              id="dosisMedicamento"
              className="pro-input"
              placeholder="Dosis"
              value={formulario.dosisMedicamento}
              onChange={(e) =>
                setFormulario({
                  ...formulario,
                  dosisMedicamento: e.target.value,
                })
              }
            />

            <Label for="dosisMedicamento">
              Dosis
            </Label>

          </FormGroup>

          {/* ESTATUS */}
          <FormGroup floating>

            <Input
              type="select"
              id="estatusMedicamento"
              className="pro-input"
              value={formulario.estatusMedicamento}
              onChange={(e) =>
                setFormulario({
                  ...formulario,
                  estatusMedicamento: e.target.value,
                })
              }
            >

              <option value="activo">
                Activo
              </option>

              <option value="inactivo">
                Inactivo
              </option>

            </Input>

            <Label for="estatusMedicamento">
              Estado
            </Label>

          </FormGroup>

        </Form>

      </ModalBody>

      <ModalFooter className="border-0 pt-0">

        <Button
          className="pro-btn-cancel"
          onClick={closeModal}
        >

          Cancelar

        </Button>

        <Button
          className="pro-btn-save"
          onClick={
            isEditing
              ? editarMedicamento
              : guardarMedicamento
          }
        >

          {isEditing
            ? "Guardar Edición"
            : "Guardar"}

        </Button>

      </ModalFooter>

    </Modal>

  </div>
);
  

};
export default MedicamentosList;
